document.addEventListener(
    "DOMContentLoaded",
    () => {
        //mmOpenCart();
    },
    { once: true }
);
// splide cross sell
function mmInitSplideCross() {
    const id = '.splide-cross';
    const splideElem = document.querySelector(id);

    if (splideElem) {
        new Splide(splideElem, {
			type: 'loop', 
            autoWidth: true, 
            focus: 'center', 
            arrows: true,
            pagination: true,
            rewind: false, 
            gap: '65px', 
            perPage: 1, 
			padding: { left: '20px', right: '20px' },
            start: 0 
        }).mount();
    }
}
mmInitSplideCross();

function returnShopifySectionId() {
  const cartElem = document.querySelector('.mm-drawer-cart-wrapper');
  const cartSection = cartElem.closest('.shopify-section');
  return cartSection.id;
}
function returnShopifySectionIdShort() {
  return returnShopifySectionId().replace('shopify-section-', '');
}

function debounce(func, duration) {
    let timeout;
    return function (...args) {
        const effect = () => {
            timeout = null;
            return func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(effect, duration);
    };
}

function mmCartSectionElement() {
    return document.querySelector(`#${returnShopifySectionId()}`);
}

function mmCartProductsContainerElement() {
    return mmCartSectionElement().querySelector(".mm-dc-products-container");
}

function mmCartItem(productVariantId) {
    return mmCartProductsContainerElement().querySelector(`[data-cart-item-id="${productVariantId}"]`);
}

function mmCartItemQuantityEl(productVariantId) {
    const itemEl = mmCartItem(productVariantId);

    return itemEl.querySelector("[data-item-quantity]");
}

function mmGetCartItemQuantity(productVariantId) {
    const quantityEl = mmCartItemQuantityEl(productVariantId);

    return Number.parseInt(quantityEl.dataset.itemQuantity);
}

function mmSetCartItemQuantity(productVariantId, newQuantity) {
    // Display qtty in front
    if (newQuantity >= 0) {
        const quantityEl = mmCartItemQuantityEl(productVariantId);

        quantityEl.dataset.itemQuantity = newQuantity;
        quantityEl.innerText = newQuantity;
    }
}

function mmAPIRequest(method, path, body) {
    document.querySelector(".mm-dc-products")?.classList?.add("mm-inactive");
    return fetch(window.Shopify.routes.root + path, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    })
    .then((response) => response.json())
    .then((data) => {
        document.querySelector(".mm-dc-products")?.classList?.remove("mm-inactive");
        if (data.status && data.status > 400) {
            throw data;
        } else {
            return data;
        }
    });
}

// récupérer le panier
function mmGetCart() {
    return mmAPIRequest("GET", "cart.js");
}

// Ouvrir le panier
function mmOpenCart() {
    mmGetCart();
    document.querySelector(".mm-drawer-cart-wrapper").classList.add("mm-dc-is-open");
    document.querySelector("html").classList.add("stop-scrolling");
}

window.mmOpenCart = mmOpenCart;

// Fermer le panier
function mmCloseCart() {
    document.querySelector(".mm-drawer-cart-wrapper").classList.remove("mm-dc-is-open");
    document.querySelector("html").classList.remove("stop-scrolling");
}

// Re-render cart inner HTML from response
function refreshCartFromData(data) {
    const newCartEl = document.createElement("DIV");
    newCartEl.innerHTML = data.sections[returnShopifySectionIdShort()];
    const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-wrapper");  
    innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-wrapper").innerHTML;
    updateCartCount();
    // setupNote();
	mmInitSplideCross();
    return data;
}

// Ajouter un item au panier
function mmAddProductToCart(variantId, { quantity = 1, openCart = true }, properties = {}) {
    if (Object.keys(properties).length != 0) {
        mmAPIRequest("POST", "cart/add.js", {
            items: [{ quantity: quantity, id: variantId, properties: JSON.parse(properties) }],
            sections: returnShopifySectionIdShort(),
        })
        .then(refreshCartFromData)
        .then((data) => {
            if (openCart) {
                setTimeout(mmOpenCart);
            }
        })
        .catch((error) => {
            console.log('error : ',error);
        });
    } else {
        mmAPIRequest("POST", "cart/add.js", {
            items: [{ quantity: quantity, id: variantId}],
            sections: returnShopifySectionIdShort(),
        })
		.then(mmAddOrRemoveFreeProducts)
        .then(refreshCartFromData)
        .then((data) => {
            if (openCart) {
                setTimeout(mmOpenCart);
            }
        })
        .catch((error) => {
            console.log('error : ',error);
        });
    }
}

// Ajouter plusieurs items au panier
function addMultipleProductsToCart(products, { openCart = true } = {}) {
    // products should be an array of objects like:
    // [{ variantId: 123, quantity: 1, properties: {...} }, ...]
    
    if (!Array.isArray(products) || products.length === 0) {
        console.error('addMultipleProductsToCart: products must be a non-empty array');
        return;
    }

    // Prepare items array for Shopify API
    const items = products.map(product => {
        const item = {
            id: product.variantId,
            quantity: product.quantity || 1
        };
        
        // Add properties if they exist
        if (product.properties && Object.keys(product.properties).length > 0) {
            // Check if properties need to be parsed (if it's a string)
            item.properties = typeof product.properties === 'string' 
                ? JSON.parse(product.properties) 
                : product.properties;
        }
        
        return item;
    });

    // Check if any items have properties
    const hasProperties = items.some(item => item.properties);

    if (hasProperties) {
        // If any item has properties, we don't run the free products logic
        mmAPIRequest("POST", "cart/add.js", {
            items: items,
            sections: returnShopifySectionIdShort(),
        })
        .then(refreshCartFromData)
        .then((data) => {
            if (openCart) {
                setTimeout(mmOpenCart);
            }
        })
        .catch((error) => {
            console.log('error : ', error);
        });
    } else {
        // If no items have properties, run the free products logic
        mmAPIRequest("POST", "cart/add.js", {
            items: items,
            sections: returnShopifySectionIdShort(),
        })
        .then(mmAddOrRemoveFreeProducts)
        .then(refreshCartFromData)
        .then((data) => {
            if (openCart) {
                setTimeout(mmOpenCart);
            }
        })
        .catch((error) => {
            console.log('error : ', error);
        });
    }
}

function mmIncreaseProductQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    const newQuantity = quantity + 1;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmDecreaseProductQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    const newQuantity = quantity - 1;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmDestroyProductFromCart(productVariantId) {
    const newQuantity = 0;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmPushNewQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);

    mmAPIRequest("POST", "cart/change.js", {
        id: productVariantId.toString(),
        quantity: quantity,
        sections: returnShopifySectionIdShort(),
    })
    .then(mmAddOrRemoveFreeProducts)
    .then(refreshCartFromData);
}

const mmDebouncedPushNewQuantity = debounce(function (productVariantId) {
    mmPushNewQuantity(productVariantId);
}, 300);


function updateCartCount() {
  const cart_count = parseInt(document.querySelector('.mm-dc-header').dataset.cartCount);
  const bubble = document.querySelector(".cart-count-bubble");
  
   if (cart_count > 0) {
      bubble.classList.remove("mm-none");
      bubble.innerHTML = `<span aria-hidden="true">${cart_count}</span>`;     
   } else {
      bubble.classList.add("mm-none");
   }
}

function mmDestroyLineItemFromCart(line_index, clickedElem) {
    mmAddLoaderToButton(clickedElem);

    setTimeout(() => {
      mmAPIRequest("POST", "cart/change.js", {
          line: parseInt(line_index),
          quantity: 0,
          sections: returnShopifySectionIdShort(),
      })
      .then(mmAddOrRemoveFreeProducts)
      .then(refreshCartFromData);
    }, "0");
}

function mmCartNoteInputChanged(input) {
  const noteElem = input.closest('.mm-dc-note-container');
  const textarea = noteElem.querySelector('#CartNote');
  textarea.value = '';
  addNoteToLocalStorage(textarea.value);
  
  if (input.checked) {
    textarea.classList.add('mm-visible');
  } else {
    textarea.classList.remove('mm-visible');  
  }
}

function mmAddLoaderToButton(buttonContainer) {
  buttonContainer.classList.add('mm-loading');
}

function addNoteToLocalStorage(note) {
  //console.log(note);
  localStorage.setItem("cartNote", note);
  // syncTrueInput(note);
}

/**
function setupNote() {
  const note = localStorage.getItem("cartNote"); 
  const noteCheckboxInput = document.querySelector('#mm_dc_note_input');
  const noteTextarea = document.querySelector('#CartNote');
  
  if(note != null && note != '') {
    noteCheckboxInput.checked = true;
    noteTextarea.classList.add('mm-visible');
    noteTextarea.value = note;
  } else {
    noteTextarea.value = '';    
  }
  
  addIdToInput();
}

function syncTrueInput(note) {
  const trueInput = document.querySelector('#TrueCartNote');
  trueInput.value = note;
  addIdToInput();
}

document.addEventListener("DOMContentLoaded", (event) => {
  setupNote();
});

function addIdToInput() {
  const id = generateShortUniqueId();
  const input = document.querySelector('#CartNote');
  const trueInput = document.querySelector('#TrueCartNote');
  const local_text = trueInput.dataset.idText;

  const current_inputValue = input.value;  
  console.log('text', `${current_inputValue} || ${local_text}: ${id}`)
  trueInput.value = `${current_inputValue} || ${local_text}: ${id}`;
}

function generateShortUniqueId() {
  const timestamp = Date.now().toString(36); // Conversion en base 36
  const randomPart = Math.floor(Math.random() * 10000).toString(36); // Conversion en base 36
  return `${timestamp}-${randomPart}`;
}
 */

function mmAddOrRemoveFreeProducts(data) {
    if (data.sections[returnShopifySectionIdShort()]) {
        console.log('in')
        const el = document.createElement("DIV");
        el.innerHTML = data.sections[returnShopifySectionIdShort()];
        const freeProductEls = el.querySelector("[data-free-products]");
        let freeProductCounts = 0;

        // creates an object like { 44058675: 1, 44058001: 0 }
       // where key is free product id and value, its quantity
       const productsParams = Array.from(freeProductEls.children).reduce((param, freeProductEl) => {
           console.log('freeProductEl', freeProductEl)
           const productId = freeProductEl.dataset.productId;
           const variantId = freeProductEl.dataset.variantId;
           const isFree = freeProductEl.dataset.freeProduct == "true";
           const itemEl = mmCartItem(variantId);
           console.log('isFree', isFree)
           console.log('itemEl', itemEl)
           if (isFree) {
             freeProductCounts += 1;
           }
           if (itemEl && isFree) {
             console.log('do nothing, item is already added');
           } else if (itemEl && !isFree) {
             console.log('item is present but should be removed');
             param[variantId] = 0;
           } else if (!itemEl && isFree) {
             console.log('item is absent but should be added');        
             param[variantId] = 1;    
           }
           return param;
       }, {});
    
       // Add or remove free products only if needed
      console.log('productsParams', productsParams)
       if (Object.keys(productsParams).length > 0) {
         mmAPIRequest('POST', 'cart/update.js', { updates: productsParams, sections: returnShopifySectionIdShort() })
           .then(refreshCartFromData)
           .then(updateCartCount);
       }
       return data;
    }
}

window.mmAddOrRemoveFreeProducts = mmAddOrRemoveFreeProducts;
window.addMultipleProductsToCart = addMultipleProductsToCart;
window.mmAddLoaderToButton = mmAddLoaderToButton;